import { EffectIndex } from '@/define/define'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { DeviceManager } from '@/service/device'
import { DevicePid } from '@/define/define'
import firmware from '@/upgrade/firmware'
import { Fe87v2DeviceList } from '@/define/device_vendor'
import { LIGHT_EFFECT_LIST_PRO_V140, LIGHT_EFFECT_LIST_PRO_V130 } from './light/light_effect_list'

export async function lightDataByVersion(lightEffectList: { [name: LightEffectModeType]: number }): Promise<{ [name: LightEffectModeType]: number }> {
  if ([...devicePro, ...deviceCyan, ...Fe87v2DeviceList].includes(DeviceManager.instance.state.currentPid) == false) {
    return lightEffectList
  }
  const fwVersionBetween104106 = await firmware.fwVersionBetween('1.0.4', '1.0.6', devicePro)
  if (fwVersionBetween104106) {
    return lightEffectList_140
  }
  const fwVersionLessThan112 = await firmware.fwVersionLessThan('1.1.2', deviceCyan)
  if (fwVersionLessThan112) {
    return lightEffectList_140
  }
  const fwVersionLessThan104 = await firmware.fwVersionLessThan('1.0.4', devicePro)
  if (fwVersionLessThan104) {
    return lightEffectList_130
  }
  const fwVersionGT212 = await firmware.fwVersionGreaterThanOrEqual('2.1.2', [...Fe87v2DeviceList])
  if (fwVersionGT212) {
    return fe87v2lightEffectList_212
  }
  return lightEffectList
}

export const devicePro: DevicePid[] = [DevicePid.IROKNa87Pro, DevicePid.IROKNd63, DevicePid.IYXMu68Pro]

const deviceCyan: DevicePid[] = [DevicePid.IROKNd63_cyan, DevicePid.IYXMu68Pro_cyan]

const lightEffectList_130: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_PRO_V130

const lightEffectList_140: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_PRO_V140

const fe87v2lightEffectList_212: { [name: LightEffectModeType]: EffectIndex } = {
  [LightEffectMode.Static_pro]: 3,
  [LightEffectMode.SaturatedStyle_FE87]: 0,
  [LightEffectMode.Prosperity_FE87]: 1,
  [LightEffectMode.SpinningWindmill_1]: 6,
  [LightEffectMode.Scanning_2]: 5,

  [LightEffectMode.ClickHighlight_pro]: 0x11,
  [LightEffectMode.ShadowChase_pro]: 0x12,
  [LightEffectMode.KeyRipple_pro]: 0x14,

  [LightEffectMode.SideStatic]: 0x0,
  [LightEffectMode.SideFleeting]: 0x1,
  [LightEffectMode.SideSpectrumCycle]: 0x2,
  [LightEffectMode.SideBreathing]: 0x3,
}
